import React, { useMemo, useState } from "react";
import TableOrganism from "../../organisms/Table/TableOrganism";
import { CenterWrapper, Container, HeaderWrapper, LeftWrapper, RightWrapper, useStyles } from "./AdminTablePageStyles";
import { useHistory, useLocation, withRouter } from "react-router-dom";
import { createAdminTableRows } from "./AdminTableData";

import { createHeaderRow } from "../../utilities/CreateHeaderRow";
import { useQuery, useQueryClient } from "react-query";
import { AdminTable } from "../../network/models/TableInterfaces";
import { useLoaderDispatch } from "../../context/LoaderContext";
import { startLoading, stopLoading } from "../../context/actions/loaderActions";
import useApiService from "../../utilities/useApiService";
import { usePharmacyEnabledStatus } from "../../context/PharmacyEnabledStatusContext";
import { useNotificationCount } from "../../context/NotificationContext";
import { Box, Pagination } from "@mui/material";
import { Button, Input } from "@material-ui/core";
import FieldProcessorModal from "../../organisms/FieldProcessorUserManagment/FieldProcessorModal";
import TemporaryNdcModal from "../../organisms/TemporaryNdcAdminModal/TemporaryNdcModal";
import { useAuthState } from "../../context/AuthContext";
import { UserRole } from "../../utilities/Enums";
import { isUserRoleEqual } from "../../utilities/checkUserRole";
import {
  DEFAULT_ADMIN_HOME_LIST_QUERY,
  buildAdminHomeListSearch,
  parseAdminHomeListQuery,
} from "../../utilities/adminHomeListQuery";

export interface AdminTablePageProps {}
const AdminTablePage: React.FC<AdminTablePageProps> = (props) => {
  const { user } = useAuthState();
  const [sortedData, setSortedData] = useState<any>([]);
  const [sortDirection, setSortDirection] = useState("asc");
  const pageSize = 10;
  const location = useLocation();
  const listQuery = useMemo(
    () => parseAdminHomeListQuery(location.search),
    [location.search]
  );
  const { page: apiPage, searchValue } = listQuery;
  const currentPage = apiPage + 1;
  const {
    pharmacyEnabledStatusMap,
    setPharmacyEnabledStatus,
    setInitialValues,
  } = usePharmacyEnabledStatus();
  const { setNotificationCount } = useNotificationCount();
  const loaderDispatch = useLoaderDispatch();
  let history = useHistory();
  const queryClient = useQueryClient();
  const { getMethod } = useApiService();
  const [openFieldProcessorModal, setOpenFieldProcessorModal] = useState(false);
  const [openTempNdcModal, setOpenTempNdcModal] = useState(false);

  const fetchPharmacies = async (page: number, size: number) => {
    startLoading(loaderDispatch);
    let countResponse = await getMethod(`admin/notifications/unseen-count`);
    let count = countResponse.data;
    setNotificationCount(count);

    const response = await getMethod(
      `/admin/dashboard?page=${page}&size=${size}&searchValue=${searchValue}`
    );
    stopLoading(loaderDispatch);
    setInitialValues(response.data.content);
    setSortedData(response.data.content);
    return response.data;
  };
  const { data: adminTableData } = useQuery(
    ["adminTable", currentPage, pageSize, searchValue],
    () => fetchPharmacies(apiPage, pageSize)
  );
  const returnedData: Array<AdminTable> = sortedData;
  const rows: Array<any> = sortedData
    ? createAdminTableRows(
          returnedData,
          history,
          setPharmacyEnabledStatus,
          pharmacyEnabledStatusMap,
          queryClient
        )
    : [];
  const headerTitles = [
    "Pharmacies",
    "User Account",
    "Return Requests",
    "Enable/Disable",
  ];
  const handleSort = () => {
    if (sortDirection === "asc") {
      const newData = [
        ...sortedData.sort((a: any, b: any) =>
          b.accountUsername.localeCompare(a.accountUsername)
        ),
      ];
      setSortDirection("desc");
      setSortedData(newData);
    } else {
      const newData = [
        ...sortedData.sort((a: any, b: any) =>
          a.accountUsername.localeCompare(b.accountUsername)
        ),
      ];
      setSortDirection("asc");
      setSortedData(newData);
    }
  };
  const updateListQuery = (
    updates: Partial<typeof DEFAULT_ADMIN_HOME_LIST_QUERY>,
    push = false
  ) => {
    const nextSearch = buildAdminHomeListSearch({
      ...listQuery,
      ...updates,
    });
    if (nextSearch === location.search) {
      return;
    }
    const nextLocation = {
      pathname: location.pathname,
      search: nextSearch,
    };
    if (push) {
      history.push(nextLocation);
    } else {
      history.replace(nextLocation);
    }
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    updateListQuery({ page: page - 1 }, true);
  };
  const classes = useStyles();

  return (
    <Container>
      <HeaderWrapper>
        <LeftWrapper>
          {isUserRoleEqual(user?.role, UserRole.Admin) && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenTempNdcModal(true)}
            >
              Manage Temporary NDCs
            </Button>
          )}
        </LeftWrapper>
        <CenterWrapper>
          <Input
            id="searchField"
            type="text"
            value={searchValue}
            onChange={(e) => {
              updateListQuery({ searchValue: e.target.value, page: 0 });
            }}
            placeholder="Search By User Account or By Pharmacy Name"
            className={classes.searchField}
          />
        </CenterWrapper>
        <RightWrapper>
          {isUserRoleEqual(user?.role, UserRole.Admin) && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenFieldProcessorModal(true)}
          >
            Manage Field Processors
          </Button>
          )}
        </RightWrapper>
      </HeaderWrapper>
      {isUserRoleEqual(user?.role, UserRole.Admin) && (
      <FieldProcessorModal
        open={openFieldProcessorModal}
        onClose={() => setOpenFieldProcessorModal(false)}
      />
      )}
      <TemporaryNdcModal
        open={openTempNdcModal}
        onClose={() => setOpenTempNdcModal(false)}
      />
      <TableOrganism
        rows={rows}
        header={createHeaderRow(headerTitles, handleSort)}
      />
      <Box className={classes.paginationContainer}>
        <Pagination
          count={adminTableData?.totalPages}
          page={currentPage}
          onChange={handlePageChange}
        />
      </Box>
    </Container>
  );
};
export default withRouter(AdminTablePage);
